export const CLEAR_ENUMS = "CLEAR_ENUMS";
export const GET_ENUM = "GET_ENUM";
export const GET_ENUM_SUCCESS = "GET_ENUM_SUCCESS";
export const GET_ENUM_EXISTING = "GET_ENUM_EXISTING";
export const GET_ENUM_FETCHING = "GET_ENUM_FETCHING";



// WEBPACK FOOTER //
// ./src/utils/enums/enumActionTypes.js